(function ($, App, Utils, Components) {

    var logger = new Logger("CatchEvent");

    Components.create('CatchEvent', {

        Selectors: {
            handle: $('[data-catch-from]'),
            handleReverse: $('[data-catch-to]')
        },

        bindEvents: () => {
            let handles = $(Components.CatchEvent.Selectors.handle);
            if (handles) {
                handles.each((e) => {
                    let $this = $(handles[e]),
                        $bound = $($this.data('catchFrom')),
                        what = $this.data('catchWhat'),
                        translate = $this.data('catchTranslate') || what;

                    if ($bound.length) {
                        $bound.on(what, (t) => {
                            Components.CatchEvent.reTrigger(t, $bound, translate, $(this).val() || $(this).data("value"));
                        });
                    }
                });
            }

            handles = $(Components.CatchEvent.Selectors.handleReverse);
            if (handles) {
                handles.each((e) => {
                    let $this = $(handles[e]),
                        $bound = $($this.data('catchTo')),
                        what = $this.data('catchWhat'),
                        translate = $this.data('catchTranslate') || what;

                    if ($bound.length) {
                        $this.on(what, (t) => {
                            Components.CatchEvent.reTrigger(t, $bound, translate, $(t.target).val() || $(t.target).data("value"));
                        });
                    }
                });
            }
        },

        reTrigger: (original, $target, newEvent, value) => {
            original.preventDefault();
            original.stopImmediatePropagation();
            $target.val(value).trigger(newEvent);
        },

        init: () => {
            Components.CatchEvent.bindEvents();
        }

    });

})(jQuery, window.App, window.App.Utils, window.App.Components);